<template>
	<div>
		<ion-menu menu-id="result-menu" content-id="main-content" side="start">
			<ion-header>
				<ion-toolbar>
					<ion-menu-toggle menu="result-menu" slot="start">
						<ion-icon :icon="icons.closeOutline"></ion-icon>
					</ion-menu-toggle>

					<ion-buttons slot="end">
						<ion-button @click="close">
							{{ $t('Zmeniť obdobie') }}
						</ion-button>
					</ion-buttons>
				</ion-toolbar>
			</ion-header>

			<ion-content>
				<div class="date-range">
					<div v-if="!filter?.last_result?.start">
						<span>{{ $t('Pre celé obdobie ') }}</span>
					</div>
					<div v-else>
						<span class="max-sm:hidden">{{ $t('pre obdobie ') + filter?.last_result?.start + ' - ' + filter?.last_result?.end }}</span>
						<span class="hidden max-sm:block">{{ filter?.last_result?.start + ' - ' + filter?.last_result?.end }}</span>
					</div>
				</div>
				<A-patients-list v-model="filter" :selected-patient-id="selectedPatientId" :patients="patients" :loading="loading" @select-patient="$emit" @close-sidemenu="closeSidemenu" />
			</ion-content>
		</ion-menu>
	</div>
</template>

<script>
import { closeOutline } from 'ionicons/icons'
import { calendar } from '@/plugins/@medirex/icons'
import { menuController } from '@ionic/vue'

import APatientsList from './a-patients-list.vue'

export default {
	emits: ['close', 'select-patient'],

	components: { APatientsList },

	props: {
		modelValue: {
			type: [Object, null],
			default: () => null
		},
		selectedPatientId: {
			type: [Number, String, null],
			required: true
		},
		patients: {
			type: [Object, null],
			required: true
		},

		loading: {
			type: Boolean,
			default: false
		}
	},

	setup() {
		return {
			icons: {
				closeOutline,
				calendar
			}
		}
	},

	computed: {
		filter: {
			get() {
				if (!this.modelValue) return null
				return this.modelValue
			},
			set(value) {
				this.$emit('update:modelValue', value)
			}
		}
	},

	methods: {
		close() {
			this.$emit('close')
		},

		async closeSidemenu() {
			await menuController.close('result-menu')
		}
	}
}
</script>

<style lang="sass" scoped>
@import '@/plugins/app/theme/_mixins/responsive.mixin'
ion-menu
	--width: 80%

	+sm
		--width: 90%

ion-content
	--padding-start: 16px
	--padding-end: 16px
	--padding-top: 20px

	+sm
		--padding-start: 0px
		--padding-end: 0px
		--padding-top: 0px

ion-icon
	cursor: pointer
	padding-left: 16px

	+sm
		padding-left: 0

ion-header,
ion-toolbar,
ion-footer,
ion-title
	--background: var(--mdx-color-background)
	--border-style: none

	+md
		@apply text-sm

ion-header
	ion-icon
		font-size: 22px
		margin-top: 7px

	ion-title
		--padding-start: 0px
		--padding-end: 0px
		padding-inline-start: 32px
		padding-inline-end: 16px

span
	@apply font-normal ml-[5px] mr-[22px]

ion-buttons ion-button
	@apply text-base

	+md
		@apply text-sm

.date-range
	@apply mx-[14px] mt-[10px] mb-[-5px] text-[--ion-color-medium]
</style>
